import { MANAGERDROUPDOWN_SUCCESS, MANAGERDROUPDOWN_FAIL } from '../actionTypes';

const initialState = {
    user: [],
    loading: false
};

const managerDroupDownReducer = (state = initialState, action) => {
    switch (action.type) {
        case MANAGERDROUPDOWN_SUCCESS:
            return {
                ...state,
                loading: true,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case MANAGERDROUPDOWN_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default managerDroupDownReducer;
